// extracted by mini-css-extract-plugin
export var box = "_9z-1";
export var checkboxRow = "_9z-8";
export var checked = "_9z-2";
export var descriptionSpacer = "_9z-a";
export var disabled = "_9z-3";
export var icon = "_9z-6";
export var input = "_9z-0";
export var labelSpacer = "_9z-9";
export var medium = "_9z-5";
export var small = "_9z-4";
export var text = "_9z-7";